export const iconFontAwesomeAlertTriangleExclamation = (
	<i className="fa-solid fa-triangle-exclamation"></i>
);
